<template>
<svg xmlns="http://www.w3.org/2000/svg" width="50" height="85" viewBox="0 0 954 857">
  <path id="User" class="cls-1" d="M1412.15,1204.01c-49.57-161.15-160.42-273.382-289.24-273.382-128.459,0-239.064,111.612-288.826,272.042C720.342,1115.51,647,978.276,647,823.92,647,560.525,860.56,347,1124,347s477,213.525,477,476.92C1601,979.074,1526.89,1116.92,1412.15,1204.01ZM1124,608.326a141.552,141.552,0,1,0,141.58,141.552A141.563,141.563,0,0,0,1124,608.326Z" transform="translate(-647 -347)"/>
</svg>
</template>
<script>
export default {
    
}
</script>
<style>
     .cls-1 {
        fill-rule: evenodd;
        fill: currentColor
      }
</style>